var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMicIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8008 17.0999V19.7999",
    stroke: "white",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1 9V10.8C17.1 12.4709 16.4363 14.0733 15.2548 15.2548C14.0733 16.4363 12.4709 17.1 10.8 17.1C9.12914 17.1 7.52671 16.4363 6.34523 15.2548C5.16375 14.0733 4.5 12.4709 4.5 10.8V9",
    stroke: "white",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5006 4.4998C13.5006 3.00864 12.2918 1.7998 10.8006 1.7998C9.30942 1.7998 8.10059 3.00864 8.10059 4.4998V10.7998C8.10059 12.291 9.30942 13.4998 10.8006 13.4998C12.2918 13.4998 13.5006 12.291 13.5006 10.7998V4.4998Z",
    stroke: "white",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicIcon);
export default __webpack_public_path__ + "static/media/mic-icon.35dcc25eb69085205a3115aca5c26ef2.svg";
export { ForwardRef as ReactComponent };